<template>
   <div>
      <Header/>
      <Banner/>
      <Features/>
      <Secure_Avantage/>
      <Footer/>
   </div>
</template>

<script>
import Header from '../../components/home/header.vue'
import Banner from '../../components/home/banner.vue'
import Features from '../../components/home/features.vue'
import Secure_Avantage from '../../components/home/secure_avantage.vue'
import Footer from '../../components/home/footer.vue'

export default {
   components:{
      Header,
      Banner,
      Features,
      Secure_Avantage,
      Footer,
   }
}
</script>

<style lang="scss" scoped>
   @import "/home.css";
</style>